import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import goodJobSvg from '../images/goodJob.svg';
import Transition from './Dialogs/Transition';

const styles = {
	goodJobIcon: {
		display : 'inline-block',
		width : 50,
		height : 50,
		backgroundImage: `url('${goodJobSvg}')`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
	},
	title : {
		fontSize : 30,
		display: 'inline-block',
		verticalAlign: 'middle',
		paddingLeft: 5,
		paddingTop: 5,
	}
};

export default class SuccessDialog extends Component {

	constructor (props) {
		super(props);
		this.handleRequestClose = this.handleRequestClose.bind(this);
	}

	handleRequestClose() {
		this.props.onClose();
	}

	render() {
		const { successMessages } = this.props;
		return (
			<div>
				<Dialog
					open={this.props.open}
					TransitionComponent={Transition}
					onClose={this.handleRequestClose}
				>
					<DialogTitle>
						<div>
							<div style={styles.goodJobIcon} /><span style={styles.title}>Success!</span>
						</div>
					</DialogTitle>
					<DialogContent>
						<DialogContentText>
							{successMessages.map((successMessage, i) => {
								return (<span key={i}>{successMessage}<br/></span>);
							})}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button onClick={this.handleRequestClose} color="primary">
							Continue
						</Button>
					</DialogActions>
				</Dialog>
			</div>
		);
	}
}

SuccessDialog.propTypes = {
	successMessages : PropTypes.array,
	open : PropTypes.bool,
	onClose : PropTypes.func,
};